export default "__VITE_ASSET__CQbqakvF__"